import BaseApiAction from '@Actions/base-api-action';

export default class CreateChallengeSession extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'sessions-createChallengeSessionV3',
      payload: { ...this._payload  },
    });
  }
}